import { render, staticRenderFns } from "./CompSubSingle.vue?vue&type=template&id=4bab60e8&scoped=true"
import script from "./CompSubSingle.vue?vue&type=script&lang=js"
export * from "./CompSubSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab60e8",
  null
  
)

export default component.exports